/** Mirror of backend WEB_PERMISSION_MODULES — keep action keys in sync. */
export const WEB_PERMISSION_MODULES = {
  histology: {
    label: "Histology",
    actions: {
      access: "Access section",
      slides_add: "Add slides",
      slides_edit: "Edit slides",
      slides_delete: "Delete slides",
      ai_pathology: "AI Pathology",
      pins_edit: "Edit pins",
      pins_delete: "Delete pins",
    },
  },
  embryology: {
    label: "Embryology",
    actions: {
      access: "Access section",
      slides_add: "Add slides",
      slides_edit: "Edit slides",
      slides_delete: "Delete slides",
      pins_edit: "Edit pins",
      pins_delete: "Delete pins",
    },
  },
  radiology: {
    label: "Radiology",
    actions: {
      access: "Access section",
      slides_add: "Add slides",
      slides_edit: "Edit slides",
      slides_delete: "Delete slides",
      pins_edit: "Edit pins",
      pins_delete: "Delete pins",
    },
  },
  three_d_models: {
    label: "3D Models",
    actions: {
      access: "Access section",
      slides_add: "Add models",
      slides_edit: "Edit models",
      slides_delete: "Delete models",
    },
  },
  embryology_3d: {
    label: "Embryology 3D Models",
    actions: {
      access: "Access section",
      slides_add: "Add models",
      slides_edit: "Edit models",
      slides_delete: "Delete models",
    },
  },
  anatomy: {
    label: "Anatomy",
    actions: {
      access: "Access section",
      slides_add: "Add content",
      slides_edit: "Edit content",
      slides_delete: "Delete content",
    },
  },
  presentations: {
    label: "Presentations",
    actions: {
      access: "Access section",
      add: "Add presentations",
      edit: "Edit presentations",
      delete: "Delete presentations",
    },
  },
};

export const SLIDE_TYPE_MODULE = {
  his: "histology",
  emb: "embryology",
  rad: "radiology",
  three_d_model: "three_d_models",
  emb_3d_model: "embryology_3d",
  anatomy: "anatomy",
  presentation: "presentations",
};

export function emptyPermissionsState() {
  const out = {};
  for (const [moduleKey, mod] of Object.entries(WEB_PERMISSION_MODULES)) {
    out[moduleKey] = {};
    for (const actionKey of Object.keys(mod.actions)) {
      out[moduleKey][actionKey] = false;
    }
  }
  return out;
}

export function normalizePermissionsState(input) {
  const base = emptyPermissionsState();
  if (!input || typeof input !== "object") return base;
  for (const moduleKey of Object.keys(WEB_PERMISSION_MODULES)) {
    const src = input[moduleKey];
    if (!src || typeof src !== "object") continue;
    for (const actionKey of Object.keys(WEB_PERMISSION_MODULES[moduleKey].actions)) {
      base[moduleKey][actionKey] = Boolean(src[actionKey]);
    }
  }
  return base;
}
